const Header = function () {

    const Hamburger = function () {
        let element = $('[data-toggle="hamburger"]');
        let targetElement = $('.hamburger-menu');

        element.on('click', function(e) {
            $(this).toggleClass('show');
            targetElement.toggleClass('show');
        })
    }

    
    return{
        initActions: function () {
            Hamburger();
        },
        initCore: function () {
            Header.initActions()
        }
    }
}();

document.addEventListener('DOMContentLoaded', function() {
    Header.initCore();
});